import React, { Component } from 'react';
import Filter from '../filter/filter.component';
import { CustomColumns } from '../modal-popover/custom-columns';
import ButtonIcon from '../../button';
import StatusData from '../statusdata/status-data.component';
import CustomDropdownButton from '../custom-form/custom-dropdown-button.component';
import DropdownButton from '../button/dropdown-button';
import { FilterGenerateReport } from '../filter/filter-generate-report.component';



export class DetailsDashboard extends Component {
    render(){
        const dataDefaultValue={
            "FilterList": [],
            "Operatorlist": [],
            "OptionList": []
        }

        const {data= dataDefaultValue , translation, addAction, buttonMenu, hasAdditionalBtn, removeAction, applyAction,
                firstList, secondList, defaultList, saveAction, customClassName, createNewAction, tabSelectedAction,
            viewSearchAction, extractAction, children, isReadAndExtractOnly, isReadAndWrite, mapInventoryAction,
                statusData, activeStatusFilter, dropdownExtract,buttonIcon, extractListLabel, options, onSelect, isCreateButtonHidden,isRefreshTable, 
                isCustomColumns = false, isGenerate, handleFirstOptionListLoadMore, handleSecondOptionListLoadMore, onSecondMultipleSelect,
                onFirstMultipleSelect, vendorResetKey, secondOptionListIsDisabled, thirdOptionListIsDisabled, dateRangeIsDisabled, fourthOptionListIsDisabled,
                handleThirdOptionListLoadMore, onThirdMultipleSelect, accountResetKey, handleFourthOptionListLoadMore, onFourthMultipleSelect, invoiceStatusKey,
                onDateRangeChange, haveEmail, onClickSendEmail
            } =this.props

        const filterProps = {data, translation, addAction , removeAction, applyAction, customClassName, tabSelectedAction}
        const customColumnsProps = {firstList, secondList, defaultList, saveAction}
        const multiSelectProps = {handleFirstOptionListLoadMore, 
                                    handleSecondOptionListLoadMore, onFirstMultipleSelect,
                                    onSecondMultipleSelect, vendorResetKey, secondOptionListIsDisabled, thirdOptionListIsDisabled, dateRangeIsDisabled,
                                   fourthOptionListIsDisabled, onThirdMultipleSelect, handleThirdOptionListLoadMore, accountResetKey, handleFourthOptionListLoadMore, 
                                   onFourthMultipleSelect, invoiceStatusKey, onDateRangeChange }
        return(
            <div>
                {
                    isGenerate ? 
                      <FilterGenerateReport {...multiSelectProps}/>
                    :
                      <Filter {...filterProps}  />
                }
               
                <div className="horizontal-separator"></div>
                {
                    statusData &&
                    <StatusData statusData={statusData} activeStatusFilter={activeStatusFilter} /> 
                }
                { !isRefreshTable &&
                    <div className="inventory-circuit-btn-container">
                        <div>
                            {isReadAndWrite && !isCreateButtonHidden && (
                                Array.isArray(buttonMenu) && buttonMenu.length > 0 ? (
                                    <div className="container-filter-button">
                                        <DropdownButton
                                            label="Create New"
                                            items={buttonMenu}
                                            customClassName="add-new-button btn-solid-color"
                                            iconSize="17px"
                                        />
                                        {hasAdditionalBtn && (
                                            <ButtonIcon
                                                onClick={mapInventoryAction}
                                                customClassName="btn-solid-color custom-map-inventory-btn"
                                                labelName="Map Inventory"
                                            />
                                        )}
                                    </div>
                                ) : (
                                    <ButtonIcon
                                        onClick={createNewAction}
                                        iconSize="17px"
                                        customClassName="add-new-button btn-solid-color"
                                        labelName="Create New"
                                    />
                                )
                            )}
                        </div>
                        <div className="container-filter-button">
                            <ButtonIcon onClick={viewSearchAction} iconLeft="file-magnifying-glass" iconSize="17px" customClassName="header-option-list header-filter-button" labelName="Search" />

                            {!isCustomColumns && <CustomColumns {...customColumnsProps} />}

                            {haveEmail && isReadAndWrite &&
                                <ButtonIcon onClick={onClickSendEmail} iconLeft="envelope-regular" customClassName="header-option-list header-filter-button" labelName="Send Email" />
                            }

                            {
                                dropdownExtract ?
                                    (isReadAndExtractOnly || isReadAndWrite) && <CustomDropdownButton onSelect={onSelect} buttonIcon={buttonIcon} extractListLabel={extractListLabel} options={options} />
                                    :
                                    (isReadAndExtractOnly || isReadAndWrite) && <ButtonIcon onClick={extractAction} iconLeft="cloud-arrow-down" iconSize="17px" customClassName="header-option-list header-filter-button" labelName="Extract List" />
                            }
                        </div>
                    </div>
                }
                {children} 
            </div>
        )
    }
}